export function formatPrice(paiseInput: number | string | undefined | null): string {
  const paise = Number(paiseInput);
  if (isNaN(paise)) return '0.00';

  const rupees = (paise / 100).toFixed(2);
  const [intPart, decimalPart] = rupees.split('.');

  let lastThree = intPart.slice(-3);
  const otherDigits = intPart.slice(0, -3);

  if (otherDigits !== '') {
    lastThree = ',' + lastThree;
  }

  const formattedInt = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
  return `${formattedInt}.${decimalPart}`;
}
